import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { STATUS } from "#performance-evaluation/constants"
import { evaluationIdPut } from "#performance-evaluation/services/api"
import { Stack, Typography } from "@mui/material"
import { useReloadRefresh } from "app/reload"
import { useState } from "react"

export default function MyEvaluationsFinished({ evaluationId, open, setOpen }) {
	const { refresh } = useReloadRefresh()

	const [disabled, setDisabled] = useState(false)

	const success = () => refresh()

	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(evaluationIdPut, { success, end })

	const handleSubmit = () => {
		setDisabled(true)
		fetch(evaluationId, { status: STATUS.COMPLETED })
	}

	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				handleSubmit,
				title: "Finalizar evaluación",
				maxWidth: "sm",
				disabled,
			}}
		>
			<Stack spacing={1}>
				<Typography variant="body1" fontWeight={600}>
					¿Deseas finalizar la evaluación?
				</Typography>
				<Typography variant="body2" color="text.secondary">
					Al confirmar, la evaluación quedará registrada como finalizada.
				</Typography>
			</Stack>
		</DialogMaster>
	)
}
